// The unread badge: asks the database once a minute and when the app comes back. Before sql/comms.sql has run it asks once and stays quiet.
import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

const KEY = uid => 'hc_comms_unread:' + uid
const remembered = uid => { try { return JSON.parse(localStorage.getItem(KEY(uid)) || 'null') || { notices: 0, messages: 0 } } catch (e) { return { notices: 0, messages: 0 } } }
export const commsChanged = () => window.dispatchEvent(new Event('hc:comms-changed'))

export function useCommsUnread(uid) {
  const [n, setN] = useState({ notices: 0, messages: 0 })
  useEffect(() => {
    if (!uid) { setN({ notices: 0, messages: 0 }); return }
    setN(remembered(uid))
    let live = true, off = false
    const ask = async () => {
      if (off || (typeof document !== 'undefined' && document.hidden)) return
      try {
        const { data, error } = await supabase.rpc('hc_comms_unread')
        if (error) { if (error.code !== 'OFFLINE') off = true; return }   // not set up yet: no more asking until the next start
        if (!live || !data) return
        const v = { notices: Number(data.notices) || 0, messages: Number(data.messages) || 0 }
        setN(v)
        try { localStorage.setItem(KEY(uid), JSON.stringify(v)) } catch (e) {}
      } catch (e) {}
    }
    const first = setTimeout(ask, 1200), t = setInterval(ask, 60000)
    window.addEventListener('hc:comms-changed', ask)
    window.addEventListener('focus', ask)
    return () => { live = false; clearTimeout(first); clearInterval(t); window.removeEventListener('hc:comms-changed', ask); window.removeEventListener('focus', ask) }
  }, [uid])
  return n
}
